import request from './request';

import { ENDPOINT } from '../../constants/api';

const affiliates = {
  getApplicants({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/applicants',
    });
  },
  getHistory({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/history',
    });
  },
  getLink({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/link',
    });
  },
  getPayout({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/payout',
    });
  },
  getPayouts({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/payouts',
    });
  },
  getPayoutsDetails({ payoutId, signal }) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: `/referrals/payouts/${payoutId}`,
    });
  },
  getPayoutMethod({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/affiliates/config',
    });
  },
  getReferrals({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/balance',
    });
  },
  getReferralsDetails({ signal, userId }) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: `/referrals/${userId}/credits`,
    });
  },
  activateApplicant({ signal, userId }) {
    return request.post({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: `/referrals/applicants/activate/${userId}`,
    });
  },
  markPayoutAsPaid({ payoutId, signal }) {
    return request.put({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: `/referrals/payouts/${payoutId}`,
    });
  },
  rejectApplicant({ signal, userId }) {
    return request.post({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: `/referrals/applicants/reject/${userId}`,
    });
  },
  sendApplicationSurvey({ formData, signal }) {
    return request.post({
      endpoint: ENDPOINT.AUTH,
      payload: formData,
      signal,
      url: '/referrals/affiliates/survey',
    });
  },
  setPayoutMethod({ handle, signal }) {
    return request.post({
      endpoint: ENDPOINT.AUTH,
      payload: {
        payment_methods: {
          paypal_handle: handle,
        },
      },
      signal,
      url: '/referrals/affiliates/config',
    });
  },
};

export default affiliates;
